// @ts-ignore
import { Grid2, Box, Typography, Button } from '@mui/material';

import React, {useRef, useState} from 'react';
import './News.css'
import myImage from '../../assets/images/news1.png';
import myImage2 from '../../assets/images/news4.jpg';
import myImage3 from '../../assets/images/news5.jpg';
import { useNavigate } from 'react-router-dom';
const News: React.FC = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [showSecondLayer, setShowSecondLayer] = useState(false);
    const navigate = useNavigate();
    const handlePlayClick = () => {
        if (videoRef.current) {
            setShowSecondLayer(true);
            videoRef.current.play(); // Play the video
        }
    };

  return (
      <Grid2 id='news' container justifyContent="center" alignItems="start" spacing={{xs: 1, md: 2}}
             columns={{xs: 10}}
             size={{xs:10}}
      >
          <Grid2 size={{xs:10}}>
              <Typography className='nameSection'>
                  News
              </Typography>
          </Grid2>
          <Grid2 size={{xs: 10,  md: 4, lg: 3}}>
              <Box className='box' textAlign="center">
                  <Box className="ellipse"></Box>
                  <Box className='parentImg'>
                      <img src={myImage2} className={'image2 image'} alt="Coming to ICE"
                           style={{width: '100%', height: 'auto'}}/>

                      <img src={myImage3} className={'image3 image'} alt="Coming to ICE"
                           style={{width: '100%', height: 'auto'}}/>
                  </Box>
                  <Typography className='type'>
                      NEWS
                  </Typography>
                  <Typography className='titleNews'>
                      The results of our first ICE 2025 raffle are in
                  </Typography>
                  <Typography className='subtitleNews'>
                      <p>
                          First place and winner of an iPhone 16 Pro Max is Stephanie Consiglio from Entain.
                      </p>
                      <p>
                          Second place and winner of an Apple Watch series 10 is Adrian Sidowski from Gemini Development.
                      </p>
                      <p>
                          Third place and will need of Beats Headphone is Anna Wellenstein from NetBet
                      </p>
                  </Typography>
              </Box>
          </Grid2>
          <Grid2 size={{xs: 10,  md: 4, lg: 3}}>
              <Box className='box' textAlign="center">
                  <Box className="ellipse3"></Box>
                  <Box className='parentImg'>
                      <Box className={`firstLayer ${showSecondLayer ? 'fade-out' : 'fade-in'}`}>
                          <svg className={'play-btn'} onClick={handlePlayClick } width="150" height="150" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="1.5"/>
                              <path d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z" stroke="#fff" stroke-width="1.5"/>
                          </svg>
                      </Box>
                      <video
                          ref={videoRef}
                          className={'video'}
                          src={require('../../assets/video/news.mp4')}
                          // autoPlay={true}
                          muted={true}
                          loop={true}
                          controls={false}
                          // playsInline={true}
                          onEnded={() => console.log("Playback ended")} // Optional callback
                      />
                  </Box>
                  <Typography className='type'>
                      NEWS
                  </Typography>
                  <Typography className='titleNews'>
                      We’re live at ICE 2025
                  </Typography>
                  <Typography className='subtitleNews'>
                      Come visit us at the Ignite Partner Stand at Aristocrat (2H30)
                  </Typography>
              </Box>
          </Grid2>
          <Grid2 size={{xs: 10,  md: 4, lg: 3}}>
              <Box className='box' textAlign="center">
                  <Box className="ellipse"></Box>
                  <Box className='parentImg'>
                      <img src={myImage} alt="Coming to ICE"
                           style={{width: '100%', height: 'auto'}}/>
                  </Box>
                  <Typography className='type'>
                      NEWS
                  </Typography>
                  <Typography className='titleNews'>
                      Coming to ICE
                  </Typography>
                  <Typography className='subtitleNews'>
                      Meet us at ICE at the Aristocrat stand (2H30)
                  </Typography>
              </Box>
          </Grid2>
          {/*<Grid2 size={{xs: 10,  md: 4, lg: 3}}>*/}
          {/*    <Box className='box' textAlign="center">*/}
          {/*        <Box className="ellipse2"></Box>*/}
          {/*        <Box className='parentImg comingSoonImg'>*/}
          {/*            <img src={myImage2} alt="Coming to ICE"*/}
          {/*                 style={{width: '100%', height: 'auto'}}/>*/}
          {/*        </Box>*/}
          {/*        <Typography className='type'>*/}
          {/*            NEWS*/}
          {/*        </Typography>*/}
          {/*        <Typography className='titleNews'>*/}
          {/*            Coming Soon*/}
          {/*        </Typography>*/}
          {/*        <Typography className='subtitleNews'>*/}
          {/*            &nbsp;*/}
          {/*        </Typography>*/}
          {/*    </Box>*/}
          {/*</Grid2>*/}
          <Grid2 size={{xs:10}}>
              <Box className='readMoreBox' textAlign="center">
                  <Button className='readMore'  onClick={() => navigate('/news_blog')}>
                      Read More
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.976437 12.5253C0.698166 12.8321 0.721309 13.3064 1.02813 13.5847C1.33495 13.8629 1.80926 13.8398 2.08753 13.533L0.976437 12.5253ZM13.2173 0.934396C13.1971 0.520675 12.8454 0.201652 12.4316 0.221838L5.68966 0.550799C5.27594 0.570986 4.95691 0.922738 4.9771 1.33646C4.99729 1.75018 5.34904 2.0692 5.76276 2.04902L11.7556 1.75661L12.048 7.74948C12.0682 8.1632 12.42 8.48222 12.8337 8.46204C13.2474 8.44185 13.5664 8.0901 13.5463 7.67638L13.2173 0.934396ZM2.08753 13.533L13.0237 1.4748L11.9126 0.467093L0.976437 12.5253L2.08753 13.533Z" fill="black"/>
                      </svg>
                  </Button>
              </Box>
          </Grid2>
      </Grid2>
  );
};

export default News;